module.exports = __webpack_public_path__ + "img/stock5.590fc6bb.png";